var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98613",
    "data-name": "Group 98613",
    transform: "translate(-92 -553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_908",
    "data-name": "Ellipse 908",
    transform: "translate(92 553)",
    fill: "#fff",
    stroke: "#00057d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "commercial",
    d: "M14.482,6.811l1.342.776-4.943,2.853L9.539,9.665l4.768-2.753Zm-1.383-.6L8.128,9.085,8.11,9.1l-.129.075v1.655l.509.294V9.663h0a.351.351,0,0,1,.175-.3l5.115-2.952-.507-.293Zm2.956,7.753a.233.233,0,0,0,.12-.208V8.192l-4.941,2.853v5.707ZM5.589,13.761a.233.233,0,0,0,.12.208l4.822,2.783V11.045l-1.338-.772v1.455a.351.351,0,0,1-.555.286l-1.183-.682a.351.351,0,0,1-.176-.3h0V9.167L5.589,8.193v5.568ZM10.762,4.8,5.94,7.586l1.692.977.127-.074.019-.011,4.8-2.769L11,4.8a.235.235,0,0,0-.239,0Zm7.823-1.66A10.879,10.879,0,0,0,3.369,2.96a.269.269,0,0,1-.375,0L1.7,1.666a.269.269,0,0,0-.458.191V6.028a.269.269,0,0,0,.269.268H5.686a.268.268,0,0,0,.189-.458L4.591,4.553a.259.259,0,0,1-.078-.194A.263.263,0,0,1,4.6,4.167a9.167,9.167,0,0,1,15.446,6.443.24.24,0,0,0,.239.233h1.252a.233.233,0,0,0,.171-.071.227.227,0,0,0,.068-.172,10.854,10.854,0,0,0-3.186-7.459Zm1.664,12.25H16.078a.268.268,0,0,0-.189.458l1.283,1.284a.267.267,0,0,1-.006.386A9.168,9.168,0,0,1,1.719,11.076a.238.238,0,0,0-.239-.233H.229a.228.228,0,0,0-.17.072.23.23,0,0,0-.069.172,10.887,10.887,0,0,0,18.405,7.638.269.269,0,0,1,.375,0l1.289,1.289a.269.269,0,0,0,.459-.191v-4.17a.27.27,0,0,0-.269-.268Z",
    transform: "translate(102.12 563.156)",
    fill: "#00057d",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus2);
export default __webpack_public_path__ + "static/media/status2.e6f1b4739d098c7b83a6c38605888a15.svg";
export { ForwardRef as ReactComponent };